module.exports = __webpack_public_path__ + "static/media/Cafe_3.ff60d161.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/cafe/Cafe_3.png
// module id = 1321
// module chunks = 3